import React, { useRef, useEffect } from 'react';
import LoadingDots from '../Loaders/LoadingDots/LoadingDots.js';
import styles from './LessonPreview.scss.js';
import { getIframeSrc, changeCurrentSlide, isPreviewReady } from '../../../helpers/lessonPreview/index.js';
import { canAutoplay } from '../../../helpers/browser/browserFeatures.js';

const LessonPreview = _ref => {
  let {
    config,
    presentationId,
    slideNumber,
    showFullscreenButton,
    bundleId,
    fromWelcome,
    privateLibraryId,
    isReadOnly
  } = _ref;
  const iframeRef = useRef(null);
  const iframeSrc = getIframeSrc(presentationId, config, showFullscreenButton, bundleId, fromWelcome, privateLibraryId, isReadOnly);
  useEffect(() => {
    const currentRef = iframeRef.current;

    // Change the current slide in the preview when the slide number changes
    if (currentRef) {
      changeCurrentSlide(currentRef, slideNumber);
    }

    // Set the current slide in the preview when the iframe is ready
    const onMessage = event => {
      if (currentRef && isPreviewReady(event, config)) {
        changeCurrentSlide(currentRef, slideNumber);
      }
    };
    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, [config, slideNumber, iframeSrc]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper__loader
  }, /*#__PURE__*/React.createElement(LoadingDots, {
    loadingText: ""
  })), presentationId && /*#__PURE__*/React.createElement("iframe", {
    title: "Lesson preview",
    src: iframeSrc,
    allowFullScreen: true,
    allow: `microphone; camera ${canAutoplay() ? '; autoplay' : ''}`,
    className: styles.wrapper__iframe,
    ref: iframeRef
  }));
};
var LessonPreview$1 = LessonPreview;

export { LessonPreview$1 as default };
//# sourceMappingURL=LessonPreview.js.map
